/*
  Cluster (Konu Grubu) Konfigürasyonu
  Her cluster: 1 hub sayfa + 4-8 spoke test sayfası
*/

export const CLUSTERS = {
  'anksiyete-testleri': {
    slug: 'anksiyete-testleri',
    title: 'Anksiyete Testleri',
    metaDescription: 'Kaygı ve anksiyete düzeyinizi farklı açılardan değerlendirin. Sosyal anksiyete, gece kaygısı, iş kaygısı ve daha fazlası.',
    heading: 'Anksiyete Testleri',
    description: 'Kaygı farklı şekillerde kendini gösterebilir. Sosyal ortamlarda, iş hayatında, sağlık konularında veya gece yatağa girdiğinizde. Aşağıdaki testlerle kaygı düzeyinizi farklı açılardan değerlendirin.',
    tests: [
      { slug: 'kaygi-testi', name: 'Kaygı Değerlendirme Testi', desc: 'Genel kaygı ve endişe düzeyinizi ölçün' },
      { slug: 'sosyal-anksiyete-testi', name: 'Sosyal Anksiyete Testi', desc: 'Sosyal ortamlardaki kaygınızı değerlendirin' },
      { slug: 'gece-kaygi-testi', name: 'Gece Kaygısı Testi', desc: 'Gece kaygısı ve uyku öncesi endişeyi tarayın' },
      { slug: 'is-kaygisi-testi', name: 'İş Kaygısı Testi', desc: 'İş ortamındaki kaygı düzeyinizi ölçün' },
      { slug: 'saglik-anksiyetesi-testi', name: 'Sağlık Anksiyetesi Testi', desc: 'Sağlık kaygınızı değerlendirin' },
      { slug: 'performans-kaygisi-testi', name: 'Performans Kaygısı Testi', desc: 'Performans ve başarı kaygınızı tarayın' },
    ],
  },
  'uyku-testleri': {
    slug: 'uyku-testleri',
    title: 'Uyku Testleri',
    metaDescription: 'Uyku kalitenizi farklı açılardan değerlendirin. Uykusuzluk, uyku apnesi, sabah yorgunluğu ve daha fazlası.',
    heading: 'Uyku Testleri',
    description: 'İyi uyku sağlığın temelidir. Uykuya dalma güçlüğünden sabah yorgunluğuna kadar uyku kalitenizi farklı açılardan değerlendirin.',
    tests: [
      { slug: 'uyku-testi', name: 'Uyku Kalitesi Testi', desc: 'Genel uyku kalitenizi değerlendirin' },
      { slug: 'insomnia-testi', name: 'Uykusuzluk Testi', desc: 'İnsomnia belirtilerini tarayın' },
      { slug: 'uykuya-dalamama-testi', name: 'Uykuya Dalamama Testi', desc: 'Uykuya dalma güçlüğünüzü ölçün' },
      { slug: 'gece-uyanma-testi', name: 'Gece Uyanma Testi', desc: 'Gece uyku bölünmelerini değerlendirin' },
      { slug: 'sabah-yorgunluk-testi', name: 'Sabah Yorgunluk Testi', desc: 'Sabah dinlenme kalitenizi ölçün' },
      { slug: 'uyku-kalitesi-testi', name: 'Detaylı Uyku Kalitesi Testi', desc: 'Uyku düzeninizi kapsamlı değerlendirin' },
    ],
  },
  'hafiza-ve-beyin-testleri': {
    slug: 'hafiza-ve-beyin-testleri',
    title: 'Hafıza ve Beyin Testleri',
    metaDescription: 'Hafıza performansınızı ve beyin sağlığınızı farklı açılardan değerlendirin. Unutkanlık, kelime bulma güçlüğü ve daha fazlası.',
    heading: 'Hafıza ve Beyin Testleri',
    description: 'Beyin sağlığı yaşam kalitesinin temelidir. Hafıza, kelime bulma, zihinsel performans ve bilişsel yaşınızı farklı testlerle değerlendirin.',
    tests: [
      { slug: 'unutkanlik-testi', name: 'Unutkanlık Testi', desc: 'Genel hafıza performansınızı ölçün' },
      { slug: 'erken-unutkanlik-testi', name: 'Erken Unutkanlık Testi', desc: 'Erken dönem bilişsel değişimleri fark edin' },
      { slug: 'kisa-sureli-hafiza-belirtileri-testi', name: 'Kısa Süreli Hafıza Testi', desc: 'Kısa süreli hafıza zorluklarını tarayın' },
      { slug: 'kelime-bulma-guclugu-testi', name: 'Kelime Bulma Güçlüğü Testi', desc: 'Dil akıcılığı zorluklarını değerlendirin' },
      { slug: 'beyin-yasi-testi', name: 'Beyin Yaşı Testi', desc: 'Bilişsel yaşınızı tahmini olarak ölçün' },
      { slug: 'zihinsel-performans-testi', name: 'Zihinsel Performans Testi', desc: 'Genel zihinsel performansınızı değerlendirin' },
    ],
  },
  'dikkat-ve-odak-testleri': {
    slug: 'dikkat-ve-odak-testleri',
    title: 'Dikkat ve Odak Testleri',
    metaDescription: 'Dikkat ve odaklanma kapasitenizi farklı açılardan değerlendirin. Dikkat süresi, dijital dikkat dağınıklığı ve daha fazlası.',
    heading: 'Dikkat ve Odak Testleri',
    description: 'Dikkat ve odaklanma günlük yaşamın, iş performansının ve öğrenmenin temelidir. Farklı testlerle dikkat kapasitenizi değerlendirin.',
    tests: [
      { slug: 'dikkat-testi', name: 'Dikkat Testi', desc: 'Genel dikkat seviyenizi ölçün' },
      { slug: 'odaklanma-testi', name: 'Odaklanma Testi', desc: 'Odaklanma kapasitenizi değerlendirin' },
      { slug: 'dikkat-suresi-testi', name: 'Dikkat Süresi Testi', desc: 'Dikkat sürenizi ölçün' },
      { slug: 'dijital-dikkat-daginikligi-testi', name: 'Dijital Dikkat Dağınıklığı Testi', desc: 'Dijital dikkat sorunlarını tarayın' },
      { slug: 'konsantrasyon-kaybi-testi', name: 'Konsantrasyon Kaybı Testi', desc: 'Konsantrasyon kaybınızı değerlendirin' },
    ],
  },
  'stres-ve-tukenmislik-testleri': {
    slug: 'stres-ve-tukenmislik-testleri',
    title: 'Stres ve Tükenmişlik Testleri',
    metaDescription: 'Stres ve tükenmişlik düzeyinizi farklı açılardan değerlendirin. İş stresi, ilişki stresi, duygusal tükenmişlik ve daha fazlası.',
    heading: 'Stres ve Tükenmişlik Testleri',
    description: 'Stres ve tükenmişlik modern yaşamın en yaygın sorunlarındandır. Farklı kaynaklardan gelen stresi ve tükenmişlik düzeyinizi değerlendirin.',
    tests: [
      { slug: 'stres-testi', name: 'Stres Testi', desc: 'Genel stres düzeyinizi ölçün' },
      { slug: 'is-stresi-testi', name: 'İş Stresi Testi', desc: 'İş yerindeki stres düzeyinizi değerlendirin' },
      { slug: 'iliski-stresi-testi', name: 'İlişki Stresi Testi', desc: 'İlişki stres düzeyinizi ölçün' },
      { slug: 'duygusal-tukenmislik-testi', name: 'Duygusal Tükenmişlik Testi', desc: 'Duygusal tükenmişliğinizi tarayın' },
      { slug: 'mental-yorgunluk-testi', name: 'Mental Yorgunluk Testi', desc: 'Zihinsel yorgunluğunuzu değerlendirin' },
      { slug: 'stres-yonetimi-testi', name: 'Stres Yönetimi Testi', desc: 'Stresle başa çıkma kapasitenizi ölçün' },
    ],
  },
  'ogrenci-performans-testleri': {
    slug: 'ogrenci-performans-testleri',
    title: 'Öğrenci Performans Testleri',
    metaDescription: 'Öğrenci performansınızı farklı açılardan değerlendirin. Sınav stresi, ders verimliliği, motivasyon ve daha fazlası.',
    heading: 'Öğrenci Performans Testleri',
    description: 'Akademik başarı sadece çalışma süresine değil, odaklanma, motivasyon ve stres yönetimine de bağlıdır. Öğrenci performansınızı farklı açılardan değerlendirin.',
    tests: [
      { slug: 'sinav-stresi-testi', name: 'Sınav Stresi Testi', desc: 'Sınav kaygınızı değerlendirin' },
      { slug: 'ders-verimliligi-testi', name: 'Ders Verimliliği Testi', desc: 'Çalışma verimliliğinizi analiz edin' },
      { slug: 'motivasyon-testi', name: 'Motivasyon Testi', desc: 'Motivasyon düzeyinizi ölçün' },
      { slug: 'odaklanma-testi', name: 'Odaklanma Testi', desc: 'Odaklanma kapasitenizi test edin' },
      { slug: 'dikkat-suresi-testi', name: 'Dikkat Süresi Testi', desc: 'Dikkat sürenizi ölçün' },
    ],
  },
  'yasam-tarzi-testleri': {
    slug: 'yasam-tarzi-testleri',
    title: 'Yaşam Tarzı Testleri',
    metaDescription: 'Dijital alışkanlıklarınızı ve yaşam kalitenizi farklı açılardan değerlendirin.',
    heading: 'Yaşam Tarzı ve Dijital Sağlık Testleri',
    description: 'Dijital çağda telefon kullanımı, sosyal medya alışkanlıkları ve yaşam dengesi sağlığımızı doğrudan etkiler. Yaşam tarzınızı farklı testlerle değerlendirin.',
    tests: [
      { slug: 'telefon-bagimliligi-testi', name: 'Telefon Bağımlılığı Testi', desc: 'Telefon kullanım alışkanlıklarınızı değerlendirin' },
      { slug: 'sosyal-medya-bagimliligi-testi', name: 'Sosyal Medya Bağımlılığı Testi', desc: 'Sosyal medya kullanımınızı ölçün' },
      { slug: 'yasam-kalitesi-testi', name: 'Yaşam Kalitesi Testi', desc: 'Genel yaşam kalitenizi değerlendirin' },
      { slug: 'overthinking-testi', name: 'Aşırı Düşünme Testi', desc: 'Overthinking eğiliminizi ölçün' },
      { slug: 'yalnizlik-testi', name: 'Yalnızlık Testi', desc: 'Yalnızlık düzeyinizi değerlendirin' },
    ],
  },
};

/* Slug'dan cluster bul */
export function findClusterForTest(testSlug) {
  for (const [, cluster] of Object.entries(CLUSTERS)) {
    if (cluster.tests.some(t => t.slug === testSlug)) return cluster;
  }
  return null;
}
